import { Component, NgZone, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { GeneralService } from "../services/general.service";
import * as ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { MatDialogConfig, MatDialog } from "@angular/material/dialog";
import { MatTableDataSource } from "@angular/material/table";
import { ActivatedRoute } from "@angular/router";
import { ListeValeurCaracteristiqueModalComponent } from "../liste-valeur-caracteristique-modal/liste-valeur-caracteristique-modal.component";
import { AngularEditorConfig } from "@kolkov/angular-editor";
import { RechercheModalComponent } from "../recherche-modal/recherche-modal.component";
import { dataURLToBlob } from "blob-util";
import { ListeComponent } from "../liste/liste.component";
import * as XLSX from "xlsx";
import Quill from 'quill';

const icons = Quill.import('ui/icons');

icons['undo'] = `
  <svg viewBox="0 0 18 18">
    <polygon class="ql-fill ql-stroke" points="6 10 4 12 2 10 6 10"></polygon>
    <path class="ql-stroke" d="M4,12 L4,6 C4,3.79 5.79,2 8,2 L14,2"></path>
  </svg>
`;

icons['redo'] = `
  <svg viewBox="0 0 18 18">
    <polygon class="ql-fill ql-stroke" points="12 10 14 12 16 10 12 10"></polygon>
    <path class="ql-stroke" d="M14,12 L14,6 C14,3.79 12.21,2 10,2 L4,2"></path>
  </svg>
`;

const Font = Quill.import('formats/font');
Font.whitelist = ['arial', 'times-new-roman', 'courier-new', 'roboto'];
Quill.register(Font, true);
declare var $: any;
@Component({
  selector: "app-article",
  templateUrl: "./article.component.html",
  styleUrls: ["./article.component.scss"],
})
export class ArticleComponent implements OnInit {
  @ViewChild('quillEditorRef') quillEditorRef: any;
  constructor(
    private route: ActivatedRoute,
    public generalService: GeneralService,
    private router: Router,
    public dialog: MatDialog,
    private ngZone: NgZone
  ) { }
  ecArtCarMod_Label;
  param_code;
  idx = 0
  accOpen = [false, false, false, false, false]
  disabled = false;
  quillModules: any = {
    toolbar: {
      container: [
        ['undo', 'redo'],
        [{ font: ['arial', 'times-new-roman', 'courier-new', 'roboto'] }],
        [{ size: ['small', false, 'large', 'huge'] }],
        ['bold', 'italic', 'underline', 'strike'],
        [{ script: 'sub' }, { script: 'super' }],
        [{ header: [1, 2, 3, false] }],
        [{ color: [] }, { background: [] }],
        [{ align: [] }],
        [{ list: 'ordered' }, { list: 'bullet' }],
        ['link', 'image', 'video'],
        ['clean']
      ],
      handlers: {
        undo: function () {
          this.quill.history.undo();
        },
        redo: function () {
          this.quill.history.redo();
        }
      }
    },
    history: {
      delay: 500,
      maxStack: 100,
      userOnly: true
    }
  };
  editorModules = {
    toolbar: [
      ["bold", "italic", "underline", "strike"], // text styles
      [{ header: 1 }, { header: 2 }], // headers
      [{ list: "ordered" }, { list: "bullet" }], // lists
      ["link", "image"], // media
      ["clean"], // remove formatting
    ],
  };
  row;
  color;
  rowSimilaires;
  rowComplementaire;
  enregistrementTerminer = true;
  public Editor = ClassicEditor;
  categorie = {
    categorie_Code: null,
    categorie_Text: null,
    categorie_CodeP: null,
  };
  article;
  ecArtCar_Id;
  modelAll;
  listeModel;
  categorieModelSelected;
  listeCaracteristiquesArticleBrut = null;
  listeCaracteristiquesArticle = [];
  ListeCaracteristiquesAll;
  caracteristique;
  caracteristiques_Value;
  displayedColumns = ["ecArtCar_Id", "ecArtCar_Label", "ecArtCar_Val"];
  initDoc;
  img_100_122 = [];

  listeImages = [];
  imageToUpload = {
    image_100_122: { base64: null, name: "", code: "", order: 0 },
    image_420_512: { base64: null, name: "", code: "" },
    image_850_1035: { base64: null, name: "", code: "" },
    image_300_366: { base64: null, name: "", code: "" },
    image_268_327: { base64: null, name: "", code: "" },
    image_234_350: { base64: null, name: "", code: "" },
    image_150_180: { base64: null, name: "", code: "" },
  };
  allCategories = [];
  categoriesNiveau1 = [];
  categoriesNiveau2 = [];
  categoriesNiveau3 = [];
  dataSourceCaracteristique = new MatTableDataSource([]);
  successLoadData = false;
  categorieNiveau1 = [];
  categorieNiveau2 = [];
  categorieNiveau3 = [];
  index = 0;
  catNiv1 = [];
  catNiv2 = [];
  catNiv3 = [];
  activerDetailsArticle = true;
  activerFamilleArticle = false;
  activerImagesArticle = true;
  activerProduit: boolean = true;
  typeTrs: String;
  selectedImageDeatail: number = null;
  selectedImageBanniere = null;
  selectedImage;
  ds;
  nbrImageAjouter = 0;
  nbImageModifier = 0;
  buttonDisabled = false;
  showBtn = true;
  modelCaracteristiqueArticle = { ecArtCarMod_Id: "", ecArtCarMod_Label: "" };
  dataSourceProduitsComplementaire = new MatTableDataSource([]);
  dataSourceProduitsSimilaires = new MatTableDataSource([]);
  displayedColumnsProduits = ["ecArtComp_Code", "Art_Des"];
  artComplementaire: any;
  artSimilaires: any;
  typeEtatStock = [
    { text: "Non disponible", value: 0 },
    { text: "Disponible", value: 1 },
    { text: "Sur commande", value: 2 },
  ];
  listeImgCarre = [];
  listeImgRectengle = [];
  listeImgRectengleHaurisontale = [];
  listeResolutionCarre = [136, 230, 300, 575, 1200];
  listeResolutionRectangle = [
    "100_122",
    "268_327",
    "300_366",
    "420_512",
    "850_1035",
  ];
  listeResolutionRectengleHaurisontale = ["1300_500"];
  mode: string;
  resolution: string;
  editorConfig: AngularEditorConfig = JSON.parse(
    JSON.stringify(this.generalService.editorConfig)
  );

  text = [
    ["", "", "", "", "", "", ""],
    ["", "", "", "", "", "", ""],
  ];
  listeColor = [];
  listeColor1 = [{ ArtV_Code1: "-1", color: "-1" }];

  typeArticle = [
    {
      type: "Article simple",
      value: 0,
    },
    {
      type: "Article parent",
      value: 1,
    },
    {
      type: "Article enfant",
      value: 2,
    },
  ];
  @ViewChild("listeComponen") listeComponen: ListeComponent;
  useDataBaseToSaveImage = this.generalService.useDataBaseToSaveImage;
  base_url = this.generalService.base_url;
  columns = {
    TableRD: [
      {
        TableRE_Code: "",
        TableRD_Champs: "Art_Code",
        Lg_Code: "",
        TableRD_Des: "Code",
        TableRD_Largeur: 70,
        TableRD_ReadOnly: true,
        TableRD_Format: "",
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: "*",
        User_Groupe: null,
      },
      {
        TableRE_Code: "",
        TableRD_Champs: "Art_Des",
        Lg_Code: "",
        TableRD_Des: "Désignation",
        TableRD_Largeur: 150,
        TableRD_ReadOnly: true,
        TableRD_Format: "",
        TableRD_Alligement: 0,
        TableRD_Ordre: 1,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: "*",
        User_Groupe: null,
      },
    ],
  };
  ngOnInit() {
    this.editorConfig.height = "150px";
    // this.img_300_300 = {}
    if (this.generalService.userConnecter == "") {
      this.router.navigate([""]);
    } else this.readParamUrl();
  }

  openFrmRechercheArticle() {
    var dialogRef = this.dialog.open(RechercheModalComponent);
    dialogRef.afterClosed().subscribe((article) => {
      this.article.Art_Stat5 = article.Art_Code;
    });
  }
  get quillEditor() {
    return this.quillEditorRef?.quillEditor;
  }
  setCategoriesNiveau1(j) {
    this.categoriesNiveau1[j] = this.allCategories.filter((cat) => {
      return cat.categorie_CodeP == null || cat.categorie_CodeP == "";
    });
    this.categoriesNiveau1v1 = this.allCategories.filter((cat) => {
      return cat.categorie_CodeP == null || cat.categorie_CodeP == "";
    });
  }
  setOrder(order: number, image) {
    var orderImage = 0;
    if (this.generalService.isNotEmpty(image.File_Class))
      orderImage = parseInt(image.File_Class);

    if (order + orderImage > 0) {
      orderImage += order;
    }
    image.File_Class = orderImage;
    // image.File_Key = image.File_Key.split('_')[0] + '_' + orderImage
  }
  setImageDetaile() {
    //image rectengle
    this.listeImgRectengle = [];
    this.generalService
      .rechercheTable(
        this.generalService.listImageByClass + this.article.Art_Code + "," + "0"
      )
      .subscribe((res) => {
        res.forEach((element, i) => {
          if (element.File_Key == 1) {
            this.checked[i] = true;
          }
          this.listeImgRectengle.push(element);
        });
      });
  }
  imageFirst;
  listePdf = [];
  // getPdf() {
  //   console.log(11);
  //   this.listePdf = []
  //   this.generalService.rechercheTable(this.generalService.urlFindDoc + this.param_code + "_PDF,ecPDF,").subscribe(pdf => {
  //     if (pdf[0])
  //       this.listePdf = pdf
  //   });

  // }
  pdfSelected;
  getSelectedFile(pdfSelected) {
    this.pdfSelected = pdfSelected;
    this.showPdf = true;
    setTimeout(() => {
      this.getPdfContent(pdfSelected);
    }, 100);
  }
  // generateExcel1() {
  //   let finaltTab = [];
  //   // finaltTab.push(Object.keys(this.generalService.artExcel[0]));
  //   finaltTab.push(
  //     Object.keys(this.generalService.artExcel[0]).map((key) => {
  //       return key === "ecArtCarMod_Label" ? "Modéle" : key;
  //     })
  //   );
  //   this.generalService.artExcel.forEach((element) => {
  //     let tab = [];
  //     Object.keys(element).forEach((key) => {
  //       tab.push(element[key]);
  //     });
  //     finaltTab.push(tab);
  //   });
  //   // console.log(finaltTab);
  //   const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(finaltTab);
  //   const wb: XLSX.WorkBook = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

  //   // Export the Excel file
  //   XLSX.writeFile(wb, "data.xlsx");
  // }
  generateExcel() {
    let finaltTab = [];

    // Get the headers and map 'ecArtCarMod_Label' to 'Modéle'
    const headers = Object.keys(this.generalService.artExcel[0]).map((key) => {
      return key === "ecArtCarMod_Label" ? "Modéle" : key;
    });
    headers.push("categorie_Code2", "categorie_Code3");
    finaltTab.push(headers);

    // Store unique products by Art_Code
    let uniqueProducts = new Map();

    this.generalService.artExcel.forEach((element) => {
      let artCode = element["Art_Code"];
      if (!uniqueProducts.has(artCode)) {
        let newElement = { ...element };
        uniqueProducts.set(artCode, newElement);
      } else {
        let existingProduct = uniqueProducts.get(artCode);
        let count = 2;
        while (`categorie_Code${count}` in existingProduct) {
          count++;
        }
        existingProduct[`categorie_Code${count}`] = element["categorie_Code"];
      }
    });

    // Convert unique products map to array and prepare final data
    let uniqueProductArray = Array.from(uniqueProducts.values());
    uniqueProductArray.forEach((element) => {
      let tab = [];
      Object.keys(element).forEach((key) => {
        tab.push(element[key]);
      });
      finaltTab.push(tab);
    });

    // Add additional categorie_Code columns to the headers if necessary
    let maxCategorieCodeCount = 1;
    uniqueProductArray.forEach((element) => {
      let count = 1;
      while (`categorie_Code${count}` in element) {
        count++;
      }
      if (count > maxCategorieCodeCount) {
        maxCategorieCodeCount = count - 1;
      }
    });

    for (let i = 2; i <= maxCategorieCodeCount; i++) {
      finaltTab[0].push(`categorie_Code${i}`);
    }

    // Fill missing columns with empty strings
    finaltTab.forEach((row) => {
      while (row.length < finaltTab[0].length) {
        row.push("");
      }
    });
    console.log(finaltTab);
    finaltTab.forEach((element, index) => {
      const categorieIndex = finaltTab[0].indexOf("categorie_Code");
      const categorie2Index = finaltTab[0].indexOf("categorie_Code2");
      const categorie3Index = finaltTab[0].indexOf("categorie_Code3");
      if (index > 0) {
        if (element[categorieIndex] != "")
          element[categorieIndex] = this.getCatParent(
            this.allCategories.find(
              (e) => e.categorie_Code == element[categorieIndex]
            )
          )?.categorie_Text;
        if (element[categorie2Index] != "")
          element[categorie2Index] = this.getCatParent(
            this.allCategories.find(
              (e) => e.categorie_Code == element[categorie2Index]
            )
          )?.categorie_Text;
        if (element[categorie3Index] != "")
          element[categorie3Index] = this.getCatParent(
            this.allCategories.find(
              (e) => e.categorie_Code == element[categorie3Index]
            )
          )?.categorie_Text;
      }
    });

    // Create and export the Excel file
    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(finaltTab);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    // Export the Excel file
    XLSX.writeFile(wb, "data.xlsx");
  }
  findChildren(parentCode: string, categoriesList: any[]): any[] {
    // Find direct children where categorie_CodeP matches the parent code
    const children = categoriesList.filter(
      (c) => c.categorie_CodeP === parentCode
    );

    // Recursively find children for each child
    children.forEach((child) => {
      child.children = this.findChildren(child.categorie_Code, categoriesList);
    });

    return children;
  }
  ListCategories = [];
  generateExcelCat() {
    const tab = this.allCategories
      ?.filter(
        (cat) =>
          cat.categorie_Text &&
          cat.categorie_Statut == 1 &&
          (cat.categorie_CodeP == null ||
            cat.categorie_CodeP == 0 ||
            cat.categorie_CodeP == "")
      )
      .map((root) => ({
        ...root,
        children: this.findChildren(root.categorie_Code, this.allCategories),
      }));
    this.ListCategories = this.sort(tab, "categorie_Order");
    // Array to store the rows
    const rows: any[] = [];

    // Start with root categories (those with categorie_CodeP = null)
    this.ListCategories.filter((c) => c.categorie_CodeP === null).forEach(
      (root) => {
        this.extractRows(root, null, root.children || [], rows);
      }
    );

    // Convert rows to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(rows);

    // Define headers for the columns
    const headers = [
      { v: "ID", wch: 10 }, // `wch` for column width
      { v: "Catégorie", wch: 20 },
      { v: "Famille", wch: 20 },
      { v: "Sous Famille", wch: 20 },
    ];

    // Add headers to the worksheet
    XLSX.utils.sheet_add_aoa(
      worksheet,
      [["Child ID", "Parent Name", "Subparent Name", "Child Name"]],
      { origin: "A1" }
    );

    // Create a new workbook and append the worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Categories");

    // Generate and download the Excel file
    XLSX.writeFile(workbook, "categories_hierarchy.xlsx");
  }
  sort(tab, key) {
    return tab?.sort((a, b) => a[key] - b[key]);
  }
  extractRows(parent: any, subParent: any, categories: any[], rows: any[]) {
    categories.forEach((category) => {
      if (category.children && category.children.length > 0) {
        // Recursively process each child
        this.extractRows(parent, category, category.children, rows);
      } else {
        // When there's no child, we add the row (for the littlest child)
        rows.push({
          childId: category.categorie_id,
          parentName: parent ? parent.categorie_Text : null,
          subParentName: subParent ? subParent.categorie_Text : null,
          childName: category.categorie_Text,
        });
      }
    });
  }

  getCatParent(item) {
    if (item != undefined) {
      const secondecat = this.allCategories.find(
        (cat) =>
          cat.categorie_Code == item.categorie_CodeP &&
          item.categorie_Text &&
          cat.categorie_Statut == 1
      );
      if (!secondecat) return item;
      else if (
        secondecat.categorie_CodeP == "" ||
        secondecat.categorie_CodeP == null
      )
        return secondecat;
      else {
        const firstCat = this.allCategories.find(
          (cat) =>
            cat.categorie_Code == secondecat.categorie_CodeP &&
            secondecat.categorie_Text &&
            cat.categorie_Statut == 1
        );
        return firstCat;
      }
    } else {
      return null;
    }
  }
  showPdf = false;
  getImageSrc(key_file) {
    return this.generalService.getImgSrc(key_file);
  }
  getPdfContent(key_file) {
    if (this.getExtentionfile(key_file) == "pdf") {
      var url = this.getImageSrc(key_file);
      document.getElementById("pdf").innerHTML =
        "<object style='' width='100%' height='100%' type='application/pdf' data=" +
        url +
        " ></object>";
    }
  }
  getExtentionfile(docKey) {
    return docKey?.split(".")[1].toLowerCase();
  }

  logValue(value) {
    console.log(value);
  }

  tabSelectedBefore = [];
  selectImageDeatail(id: string, index: number) {
    this.selectedImageDeatail = index;
    for (var i = 1; i < this.img_100_122.length + 1; i++) {
      $("#" + this.param_code + "_100_122_" + i).attr("style", "");
    }
    $("#" + id).attr(
      "style",
      "border-color: blue;   border-style: solid;width: 100px;"
    );
  }
  lastIndexImage;
  selectionnerImage(image, mode, couleur, index) {
    console.log(this.selectedImage);
    console.log(image);
    this.lastIndexImage = index;
    if (this.tabSelectedBefore.length > 0) {
      this.tabSelectedBefore.forEach((element) => {
        $("#" + element.mode + element.couleur + element.index).attr(
          "style",
          "border-color: transparent;   border-style: none;"
        );
      });
    }
    $("#" + mode + couleur + index).attr(
      "style",
      "border-color: blue;   border-style: solid"
    );
    this.tabSelectedBefore.push({
      mode: mode,
      couleur: couleur,
      index: index,
      File_Class: image.File_Class,
    });

    this.selectedImage = image;
  }
  caracteristiquesSelected2(event, caracteristiques) {
    var caracteristique = this.modelAll.find((caracter) => {
      return caracter.ecArtCar_Id == event.option.value;
    });
    caracteristiques.ecArtCarMod_Label = caracteristique.ecArtCarMod_Label;
    caracteristiques.ecArtCar_Id = caracteristique.ecArtCar_Id;
  }
  caracteristiqueModelSelected(event) {
    this.categorieModelSelected = this.modelAll.find((cat) => {
      return cat.ecArtCarMod_Id == event.option.id;
    });
    this.modelCaracteristiqueArticle = this.generalService.clone(
      this.categorieModelSelected
    );
    if (
      this.article.Art_Stat2 == this.modelCaracteristiqueArticle.ecArtCarMod_Id
    )
      this.getCaracteristiquesArticle();
    else
      this.dataSourceCaracteristique = new MatTableDataSource(
        this.getListeCaracteristiqueModel(
          this.categorieModelSelected.ecArtCarMod_Id
        )
      );
  }
  getListeCaracteristiqueModel(ecArtCarMod_Id) {
    var data = this.ListeCaracteristiquesAll.filter((carac) => {
      return carac.ecArtCarMod_Id == ecArtCarMod_Id;
    });
    return data;
  }
  onCaracteristiqueModelValuechange(e) {
    var myList = this.generalService.clone(this.modelAll);
    var list = myList.filter((val) => {
      return (
        val.ecArtCarMod_Label
          .toLowerCase()
          .indexOf(e.target.value.toLowerCase()) >= 0
      );
    });
    if (list.length == 0) {
      list = myList;
      e.target.value = e.target.value.substr(0, e.target.value.length - 1);
    }
    if (list.length == 1) {
      this.caracteristiqueModelSelected({
        option: { id: list[0].ecArtCarMod_Id },
      });
    }
    this.listeModel = list;
  }
  selectRow(event, row, table: string) {
    var els = document.getElementsByClassName("mat-row");
    Array.prototype.forEach.call(els, function (el) {
      el.style = "";
    });
    event.currentTarget.style = "background-color: #a0bdf3;";
    if (table == "similaires") this.rowSimilaires = row;
    if (table == "complementaire") this.rowComplementaire = row;
    if (table == "caracteristique") this.row = row;
  }
  enregistrerCaracteristique() {
    console.log(14);
    this.enregistrementTerminer = false;
    this.generalService
      .rechercheTable(
        this.generalService.urlArticle + "&val=" + this.param_code
      )
      .subscribe(
        (art) => {
          this.ds = art;
          this.article = this.ds.Art[0];
          this.article.Art_Stat2 =
            this.modelCaracteristiqueArticle.ecArtCarMod_Id;
          this.generalService.enregisterTable(this.ds).subscribe(
            (art) => {
              this.generalService
                .supprimerSanMsgConfirm(this.article.Art_Code, "ecartcarval2")
                .subscribe((data) => {
                  this.generalService
                    .rechercheTable(
                      this.generalService.urlCaracteristiqueArticle
                    )
                    .subscribe(
                      (Initcar) => {
                        var nbrCaracteristiqueEnregister = 0;
                        for (
                          let i = 0;
                          i < this.dataSourceCaracteristique.data.length;
                          i++
                        ) {
                          console.log(Initcar);
                          Initcar.ecArtCarVal[0].ecArtCar_Id =
                            this.generalService.clone(
                              this.dataSourceCaracteristique.data[i].ecArtCar_Id
                            );
                          Initcar.ecArtCarVal[0].Art_Code =
                            this.generalService.clone(this.article.Art_Code);
                          Initcar.ecArtCarVal[0].ecArtCar_Val =
                            this.generalService.clone(
                              this.dataSourceCaracteristique.data[i]
                                .ecArtCar_Val
                            );
                          this.generalService
                            .enregisterTable(Initcar)
                            .subscribe(
                              (Initcar) => {
                                nbrCaracteristiqueEnregister++;
                                if (
                                  nbrCaracteristiqueEnregister ==
                                  this.dataSourceCaracteristique.data.length
                                )
                                  this.enregistrementTerminer = true;
                                this.generalService.dialogSuccess(
                                  this.dataSourceCaracteristique.data[i]
                                    .ecArtCar_Label + " enregistrer",
                                  true
                                );
                              },
                              (err) => {
                                this.generalService.dialogSuccess(
                                  this.dataSourceCaracteristique.data[i]
                                    .ecArtCar_Label + " non enregistrer",
                                  false
                                );
                                this.enregistrementTerminer = true;
                              }
                            );
                        }
                      },
                      (err) => {
                        this.generalService.dialogSuccess(
                          "Caractéristiques non enregistrer",
                          false
                        );
                        this.enregistrementTerminer = true;
                      }
                    );
                });
            },
            (err) => {
              this.enregistrementTerminer = true;
              this.generalService.dialogSuccess(
                "Caractéristiques enregistrer non enregistrer",
                false
              );
            }
          );
        },
        (err) => {
          this.enregistrementTerminer = true;
          this.generalService.dialogSuccess(
            "Caractéristiques enregistrer non enregistrer",
            false
          );
        }
      );

    // this.generalService.enregisterTable(this.dataSource.data).subscribe(data =>
    // {

    // })
  }
  getInitDoc() {
    this.generalService.rechercheTable(this.generalService.urlAvtDoc).subscribe(
      (doc) => {
        this.initDoc = doc;
      },
      (e) => {
        this.enregistrementTerminer = true;
      }
    );
  }
  checked = [];
  async onselectionChange(event, index, image) {
    console.log(event);
    console.log(this.checked);
    console.log(this.listeImgRectengle);
    console.log(index);

    await this.generalService
      .rechercheTable(
        this.generalService.urlFiles +
        "&val=" +
        this.listeImgRectengle[index].File_Id.toString()
      ).subscribe(async (data) => {
        data.Files[0].File_Key = 1;
        this.generalService.enregisterTable(data).subscribe((res) => {
          this.listeImgRectengle.forEach(async (element, i) => {
            if (i != index) {
              this.checked[i] = false;
              await this.generalService
                .rechercheTable(
                  this.generalService.urlFiles +
                  "&val=" +
                  this.listeImgRectengle[i].File_Id.toString()
                )
                .subscribe(async (data) => {
                  data.Files[0].File_Key = "";
                  await this.generalService.enregisterTable(data).subscribe((res) => { });
                });
            }
          });
        });
      })
  }

  // this.listeImgRectengle.forEach(async (element, i) => {
  //   if (i != index) {
  //     if (this.checked[i]) {
  //       this.checked[i] = false;
  //       await this.generalService
  //         .rechercheTable(
  //           this.generalService.urlFiles +
  //           "&val=" +
  //           this.listeImgRectengle[i].File_Id.toString()
  //         )
  //         .subscribe(async (data) => {
  //           data.Files[0].File_Key = "";
  //           await this.generalService.enregisterTable(data).subscribe((res) => { });
  //         });
  //     }
  //   } else {
  //     await this.generalService
  //       .rechercheTable(
  //         this.generalService.urlFiles +
  //         "&val=" +
  //         this.listeImgRectengle[i].File_Id.toString()
  //       )
  //       .subscribe(async (data) => {
  //         data.Files[0].File_Key = 1;
  //         this.generalService.enregisterTable(data).subscribe((res) => { });
  //       });
  //   }
  //   console.log(i);
  // });

  addFiles(
    initDoc,
    File_Content,
    File,
    File_Key,
    File_Type,
    File_Parent,
    clickMode,
    File_Groupe,
    File_Lien,
    taille,
    nbrImage,
    reloadImage,
    File_Class
  ) {
    var File_Text = File.name;
    var doc = this.generalService.clone(initDoc);
    if (clickMode != "renommer") {
      doc.files[0].File_Parent = File_Parent;
      doc.files[0].File_Text = this.article.Art_Code;
      doc.files[0].File_Key = "";
      // doc.files[0].File_Key = "";
      doc.files[0].File_Type = File_Type;
      doc.files[0].File_Groupe = File_Groupe;
      doc.files[0].File_Lien = File_Lien;
      doc.files[0].File_Class = File_Class;
      doc.files[0].File_Dll = this.color ? this.color : "";
      if (this.generalService.useDataBaseToSaveImage == 1) {
        doc.files[0].File_Content = File_Content;
        this.generalService.enregisterTable(doc).subscribe(
          (data) => {
            console.log(doc);

            this.generalService.dialogSuccess("image enregisté", true);
            this.nbrImageAjouter++;
            if (this.nbrImageAjouter == nbrImage) {
              if (reloadImage) this.setImageDetaile();
              this.nbrImageAjouter = 0;
              this.enregistrementTerminer = true;
            }
          },
          (err) => {
            this.enregistrementTerminer = true;
            this.generalService.dialogSuccess("image  non enregisté", false);
          }
        );
      } else if (this.generalService.useDataBaseToSaveImage == 0) {
        this.generalService.uploadFile2(File, File_Text).subscribe((data1) => {
          doc.files[0].File_Content = data1["fileName"];
          this.generalService.enregisterTable(doc).subscribe(
            (data) => {
              this.generalService.dialogSuccess("image enregisté", true);
              this.nbrImageAjouter++;
              if (reloadImage) this.setImageDetaile();
              this.nbrImageAjouter = 0;
              this.enregistrementTerminer = true;

              console.log("****** scess ");
            },
            (err) => {
              console.log("****** err ");
              this.enregistrementTerminer = true;
              this.generalService.dialogSuccess("image non enregisté", false);
            }
          );
        });
      }
    }
  }
  onChangeImagefile2(fileInput) {
    var file = fileInput.target.files[0];
    console.log(" /********/  ", file);

    var reader = new FileReader();

    if (file.type.indexOf("pdf") == 12) {
      this.enregistrementTerminerPDF = false;
      reader.onload = (e) => {
        if (this.modePdf == "ajouter") this.ajouterPdf(file);
        else if (this.modePdf == "modifier") this.modifierPDf(file);
      };
      reader.readAsDataURL(file);
    } else
      this.generalService.dialogSuccess("Veuillez sélectionner un pdf ", false);
  }
  modePdf;
  ajouterPdf(File) {
    console.log(14);
    this.generalService
      .rechercheTable(
        this.generalService.urlArticle + "&val=" + this.param_code
      )
      .subscribe((art) => {
        console.log(art);
        this.ds = art;
        var doc = this.generalService.clone(this.initDoc);
        doc.files[0].File_Parent = "";
        doc.files[0].File_Text = File.name;
        doc.files[0].File_Key = this.param_code + "_PDF";
        doc.files[0].File_Type = "ecPDF";
        doc.files[0].File_Groupe = "";
        doc.files[0].File_Lien = "";
        doc.files[0].File_Class = "";
        this.generalService.uploadFile2(File, File.name).subscribe((data1) => {
          doc.files[0].File_Content = data1["fileName"];
          this.generalService.enregisterTable(doc).subscribe(
            (data) => {
              console.log("****** 1 ");
              art.Art[0].Art_pdf = data1["fileName"];
              this.generalService
                .enregisterTable(art)
                .subscribe((updateArticle) => { });
              this.generalService.dialogSuccess("Pdf enregisté", true);
              this.enregistrementTerminerPDF = true;
              console.log("****** scess ");
              this.article = art.Art[0];
              // this.getPdf()
            },
            (err) => {
              console.log("****** err ");

              this.enregistrementTerminerPDF = true;
              this.generalService.dialogSuccess("pdf  non enregisté", false);
            }
          );
        });
      });
  }
  modifierPDf(file) {
    console.log(14);
    console.log(this.pdfSelected);

    this.generalService
      .rechercheTable(
        this.generalService.urlFiles +
        "&val=" +
        this.pdfSelected.File_Id.toString()
      )
      .subscribe((data) => {
        data.Files[0].File_Text = File.name;
        this.generalService.uploadFile2(file, file.name).subscribe((res) => {
          data.Files[0].File_Content = res["fileName"];
          this.generalService.enregisterTable(data).subscribe(
            (data1) => {
              console.log("****** 1 ");
              this.generalService
                .rechercheTable(
                  this.generalService.urlArticle + "&val=" + this.param_code
                )
                .subscribe((art) => {
                  art.Art[0].Art_pdf = res["fileName"];
                  this.generalService
                    .enregisterTable(art)
                    .subscribe((updateArticle) => {
                      this.article = art.Art[0];
                    });
                });
              this.generalService.dialogSuccess("Pdf enregisté", true);
              this.enregistrementTerminerPDF = true;
              console.log("****** scess ");
              // this.getPdf()

              this.getSelectedFile(data.Files[0]);
            },
            (err) => {
              console.log("****** err ");

              this.enregistrementTerminerPDF = true;
              this.generalService.dialogSuccess("pdf  non enregisté", false);
            }
          );
        });
      });
  }

  onChangeImagefile(fileInput) {
    console.log(" /*/*/*/  ", fileInput);
    var file = fileInput.target.files[0];
    console.log(" /********/  ", file);

    var reader = new FileReader();
    if (file.type.indexOf("image") == 0) {
      this.enregistrementTerminer = false;
      reader.onload = (e) => {
        var image = new Image();
        image.src = reader.result.toString();
        image.onload = (ev) => {
          if (this.mode == "ajouter") this.ajouterImage(file, image);
          else if (this.mode == "modifier") this.modifier_Image(file, image);
        };
      };
      reader.readAsDataURL(file);
    } else
      this.generalService.dialogSuccess(
        "Veuillez sélectionner une image ",
        false
      );
  }
  ajouterImage(file, image) {
    console.log(14);
    this.generalService
      .rechercheTable(
        this.generalService.urlArticle + "&val=" + this.param_code
      )
      .subscribe(
        (art) => {
          this.ds = art;
          this.enregistrementTerminer = false;
          if (this.resolution == "rectengle") {
            if (this.ds.Art[0].Art_NbrImages == null)
              this.ds.Art[0].Art_NbrImages = 0;
            var nbr = parseInt(this.ds.Art[0].Art_NbrImages);
            nbr++;
            this.ds.Art[0].Art_NbrImages = nbr;
            this.generalService.enregisterTable(this.ds).subscribe((data) => {
              var imagegBase64 = image;
              this.addFiles(
                this.initDoc,
                imagegBase64,
                file,
                this.param_code,
                "ecImage",
                "",
                "crerFichier",
                "",
                "",
                "",
                this.listeResolutionRectangle.length,
                true,
                this.ds.Art[0].Art_NbrImages
              );
              this.article = this.ds.Art[0];
            });
          }
        },
        (error) => {
          this.enregistrementTerminer = false;
        }
      );
  }

  modifier_Image(file, image) {
    this.nbImageModifier = 0;
    var indexImage = this.selectedImage.File_Class;
    this.selectedImage.File_Content = image.src;
    if (this.resolution == "rectengle") {
      for (let i = 0; i < this.listeResolutionRectangle.length; i++) {
        let x, y;
        // x = this.listeResolutionRectangle[i].split("_")[0];
        // y = this.listeResolutionRectangle[i].split("_")[1];
        this.generalService
          .rechercheTable(
            this.generalService.urlFindDoc + this.param_code + ",ecImage,"
          )
          .subscribe((img) => {
            let aa =
              this.generalService.urlFindDoc +
              this.param_code +
              indexImage +
              ",ecImage,";
            if (img.length > 0)
              this.modifierImage(
                file,
                img[0].File_Id,
                this.generalService.redimentionnerImage(image, x, y, 80),
                file.name,
                "",
                this.listeResolutionRectangle.length
              );
            else {
              var imagegBase64 = this.generalService.redimentionnerImage(
                image,
                this.listeResolutionCarre[i],
                this.listeResolutionCarre[i],
                80
              );
              this.addFiles(
                this.initDoc,
                imagegBase64,
                file.name,
                this.param_code + indexImage,
                "ecImage",
                "",
                "crerFichier",
                "",
                "",
                "",
                this.listeResolutionRectangle.length,
                true,
                this.selectedImage.File_Class
              );
            }
          });
      }
    }
  }
  openFrmImage(mode, resolution, color) {
    this.color = color;
    this.mode = mode;
    this.resolution = resolution;
    if (mode == "ajouter") {
      if (this.initDoc) document.getElementById("input_file99").click();
      else
        this.generalService.dialogSuccess(
          "veuillez patientez un moment pendant la chargement totale du page",
          false
        );
    } else if (mode == "modifier") {
      if (
        this.generalService.isNotEmpty(this.selectedImage) &&
        (color == this.selectedImage.File_Dll ||
          (this.listeColor1.length == 1 &&
            this.listeColor1[0].ArtV_Code1 == "-1"))
      )
        document.getElementById("input_file99").click();
      else
        this.generalService.dialogSuccess(
          "Veuillez sélectionner une image",
          false
        );
    }
  }

  onCategoriesNiveau1Valuechange(e, j, bool) {
    console.log(j);
    if (bool) {
      var allCategories = this.allCategories.filter((cat) => {
        return cat.categorie_CodeP == null || cat.categorie_CodeP == "";
      });
      var myList = allCategories;
      var list = myList.filter((val) => {
        return (
          val.categorie_Text
            .toLowerCase()
            .toLowerCase()
            .indexOf(e.target.value.toLowerCase()) >= 0
        );
      });
      if (list.length == 0) {
        list = allCategories;
        e.target.value = e.target.value.substr(0, e.target.value.length - 1);
      }
      // if (!bool)
      this.categoriesNiveau1[j] = list;
    } else {
      var allCategories = this.allCategories.filter((cat) => {
        return cat.categorie_CodeP == null || cat.categorie_CodeP == "";
      });
      var myList = allCategories;
      var list = myList.filter((val) => {
        return (
          val.categorie_Text
            .toLowerCase()
            .toLowerCase()
            .indexOf(e.target.value.toLowerCase()) >= 0
        );
      });
      if (list.length == 0) {
        list = allCategories;
        e.target.value = e.target.value.substr(0, e.target.value.length - 1);
      }
      // if (!bool)
      this.categoriesNiveau1[j] = list;
    }
  }
  categoriesNiveau1v1;
  onCategoriesNiveau1Valuechange1(e) {
    var allCategories = this.allCategories.filter((cat) => {
      return cat.categorie_CodeP == null || cat.categorie_CodeP == "";
    });
    var myList = allCategories;
    var list = myList.filter((val) => {
      return (
        val.categorie_Text
          .toLowerCase()
          .toLowerCase()
          .indexOf(e.target.value.toLowerCase()) >= 0
      );
    });
    if (list.length == 0) {
      list = allCategories;
      e.target.value = e.target.value.substr(0, e.target.value.length - 1);
    }
    // if (!bool)
    this.categoriesNiveau1v1 = list;
  }
  categoriesNiveau1Selected(event, j, bool) {
    console.log(event.option.id);
    console.log(event.option.id.substring(1));
    console.log(bool);

    if (bool) {
      this.categorieNiveau1[j] = this.allCategories.find((cat) => {
        return cat.categorie_Code == event.option.id;
      });
      this.catNiv1Id[j] = event.option.id;
      this.catNiv2Id[j] = "";
      this.catNiv3Id[j] = "";
      this.categorieNiveau2[j] = [];
      this.categoriesNiveau3[j] = [];
      this.setCategoriesNiveau2(j);
      if (j) {
        $("#" + j + "idCategoriesNiveau2").val("");
        $("#" + j + "idCategoriesNiveau3").val("");
      }
    } else {
      this.categorieNiveau1[j] = this.allCategories.find((cat) => {
        return cat.categorie_Code == event.option.id.substring(1);
      });
      this.catNiv1Id[j] = event.option.id;
      this.categorieNiveau2[j] = [];
      this.catNiv2Id[j] = "";
      this.catNiv3Id[j] = "";
      this.categoriesNiveau3[j] = [];
      this.setCategoriesNiveau2(j);
      if (j) {
        $("#" + j + "idCategoriesNiveau2").val("");
        $("#" + j + "idCategoriesNiveau3").val("");
      }
    }

    // this.article.categorie_id = this.generalService.clone(event.option.id);
  }
  categorieNiveau2v1;
  categorieNiveau3v1;
  idcategorieNiveau11;
  categoriesNiveau1Selected1(event) {
    console.log(event.option.id.substring(1));
    this.idcategorieNiveau11 = event.option.id.substring(1);
    this.categorieNiveau1v1 = this.allCategories.find((cat) => {
      return cat.categorie_Code == event.option.id.substring(1);
    });
    this.categorieNiveau2v1 = this.generalService.clone(this.categorie);
    this.categorieNiveau3v1 = this.generalService.clone(this.categorie);
    this.categoriesNiveau3 = [];
    this.setCategoriesNiveau21();
    $("#1idCategoriesNiveau2").val("");
    $("#1idCategoriesNiveau3").val("");
    this.article.categorie_id = this.generalService.clone(event.option.id);
  }
  onCategoriesNiveau2Valuechange(e, j, bool) {
    if (bool) {
      var allCategories = this.allCategories.filter((cat) => {
        return cat.categorie_CodeP == this.categorieNiveau1[j].categorie_Code;
      });
      var myList = allCategories;
      var list = myList.filter((val) => {
        return (
          val.categorie_Text
            .toLowerCase()
            .indexOf(e.target.value.toLowerCase()) >= 0
        );
      });
      if (list.length == 0) {
        list = allCategories;
        e.target.value = e.target.value.substr(0, e.target.value.length - 1);
      }
      this.categoriesNiveau2[j] = list;
    } else {
      var allCategories = this.allCategories.filter((cat) => {
        return cat.categorie_CodeP == this.categorieNiveau1[j].categorie_Code;
      });
      var myList = allCategories;
      var list = myList.filter((val) => {
        return (
          val.categorie_Text
            .toLowerCase()
            .indexOf(e.target.value.toLowerCase()) >= 0
        );
      });
      if (list.length == 0) {
        list = allCategories;
        e.target.value = e.target.value.substr(0, e.target.value.length - 1);
      }
      this.categoriesNiveau2[j] = list;
    }
  }
  categoriesNiveau2v1;
  categorieNiveau1v1;
  onCategoriesNiveau2Valuechange1(e) {
    var allCategories = this.allCategories.filter((cat) => {
      return cat.categorie_CodeP == this.categorieNiveau1v1.categorie_Code;
    });
    var myList = allCategories;
    var list = myList.filter((val) => {
      return (
        val.categorie_Text
          .toLowerCase()
          .indexOf(e.target.value.toLowerCase()) >= 0
      );
    });
    if (list.length == 0) {
      list = allCategories;
      e.target.value = e.target.value.substr(0, e.target.value.length - 1);
    }
    this.categoriesNiveau2v1 = list;
  }
  categoriesNiveau2Selected(event, j, bool) {
    console.log(event.option.id);
    console.log(bool);

    if (bool) {
      this.categorieNiveau2[j] = this.allCategories.find((cat) => {
        return cat.categorie_Code == event.option.id;
      });
      this.catNiv2Id[j] = event.option.id;
      this.catNiv3Id[j] = "";
      this.categorieNiveau3[j] = [];
      this.setCategoriesNiveau3(j);
      $("#idCategoriesNiveau3").val("");
    } else {
      this.categorieNiveau2[j] = this.allCategories.find((cat) => {
        return cat.categorie_Code == event.option.id.substring(1);
      });
      this.categorieNiveau3[j] = [];
      this.catNiv2Id[j] = event.option.id;
      this.catNiv3Id[j] = "";
      this.setCategoriesNiveau3(j);
      $("#idCategoriesNiveau3").val("");
    }

    // this.article.categorie_id = this.generalService.clone(event.option.id);
  }
  idcategorieNiveau21;
  categoriesNiveau2Selected1(event) {
    console.log(event.option.id.substring(1));
    this.idcategorieNiveau21 = event.option.id.substring(1);
    console.log(
      this.allCategories.find((cat) => {
        return cat.categorie_Code == event.option.id.substring(1);
      })
    );

    this.categorieNiveau2v1 = this.allCategories.find((cat) => {
      return cat.categorie_Code == event.option.id.substring(1);
    });
    // this.categoriesNiveau2v1 = this.allCategories.find(cat => { return cat.categorie_Code == event.option.id });
    console.log(this.categorieNiveau2v1);
    this.categoriesNiveau31 = this.generalService.clone(this.categorie);
    this.setCategoriesNiveau31();
    $("#1idCategoriesNiveau3").val("");
  }

  onCategoriesNiveau3Valuechange(e, j, bool) {
    if (bool) {
      var allCategories = this.allCategories.filter((cat) => {
        return cat.categorie_CodeP == this.categorieNiveau2[j].categorie_Code;
      });
      var myList = allCategories;
      var list = myList.filter((val) => {
        return (
          val.categorie_Text
            .toLowerCase()
            .indexOf(e.target.value.toLowerCase()) >= 0
        );
      });
      if (list.length == 0) {
        list = allCategories;
        e.target.value = e.target.value.substr(0, e.target.value.length - 1);
      }
      this.categoriesNiveau3[j] = list;
    } else {
      var allCategories = this.allCategories.filter((cat) => {
        return cat.categorie_CodeP == this.categorieNiveau2[j].categorie_Code;
      });
      var myList = allCategories;
      var list = myList.filter((val) => {
        return (
          val.categorie_Text
            .toLowerCase()
            .indexOf(e.target.value.toLowerCase()) >= 0
        );
      });
      if (list.length == 0) {
        list = allCategories;
        e.target.value = e.target.value.substr(0, e.target.value.length - 1);
      }
      this.categoriesNiveau3[j] = list;
    }
  }
  categoriesNiveau31;
  onCategoriesNiveau3Valuechange1(e) {
    var allCategories = this.allCategories.filter((cat) => {
      return cat.categorie_CodeP == this.categorieNiveau2v1.categorie_Code;
    });
    var myList = allCategories;
    var list = myList.filter((val) => {
      return (
        val.categorie_Text
          .toLowerCase()
          .indexOf(e.target.value.toLowerCase()) >= 0
      );
    });
    if (list.length == 0) {
      list = allCategories;
      e.target.value = e.target.value.substr(0, e.target.value.length - 1);
    }
    this.categoriesNiveau31 = list;
  }
  valueCatNiv1(event) {
    this.categorieNiveau1v1 = this.allCategories.find((cat) => {
      return cat.categorie_Code == event.option.id.substring(1);
    });
  }
  valueCatNiv2(event) {
    this.categorieNiveau2v1 = this.allCategories.find((cat) => {
      return cat.categorie_Code == event.option.id.substring(1);
    });
  }
  valueCatNiv3(event) {
    this.categorieNiveau31 = this.allCategories.find((cat) => {
      return cat.categorie_Code == event.option.id.substring(1);
    });
  }

  categorieNiveau31;
  idcategorieNiveau31;
  categoriesNiveau3Selected1(event) {
    console.log(event.option.id.substring(1));
    this.idcategorieNiveau31 = event.option.id.substring(1);
    this.categorieNiveau31 = this.allCategories.find((cat) => {
      return cat.categorie_Code == event.option.id.substring(1);
    });
    // this.article.categorie_id = this.generalService.clone(event.option.id);
  }
  categoriesNiveau3Selected(event, j, bool) {
    console.log(event.option.id);
    if (bool) {
      this.categorieNiveau3[j] = this.allCategories.find((cat) => {
        return cat.categorie_Code == event.option.id;
      });
      this.ListCat[j].categorie_Code = this.categorieNiveau3[j].categorie_Code;
      this.catNiv3Id[j] = event.option.id;
    } else {
      this.categorieNiveau3[j] = this.allCategories.find((cat) => {
        return cat.categorie_Code == event.option.id;
      });
      this.ListCat[j].categorie_Code = this.categorieNiveau3[j].categorie_Code;
      this.catNiv3Id[j] = event.option.id;
    }
    // this.article.categorie_id = this.generalService.clone(event.option.id);
  }
  setCategoriesNiveau3(j) {
    console.log(this.categorieNiveau2);

    this.categoriesNiveau3[j] = this.allCategories.filter((cat) => {
      return cat.categorie_CodeP == this.categorieNiveau2[j].categorie_Code;
    });
  }
  setCategoriesNiveau31() {
    console.log(this.categorieNiveau2v1);

    console.log(
      this.allCategories.filter((cat) => {
        return cat.categorie_CodeP == this.categorieNiveau2v1.categorie_Code;
      })
    );

    this.categoriesNiveau31 = this.allCategories.filter((cat) => {
      return cat.categorie_CodeP == this.categorieNiveau2v1.categorie_Code;
    });
    console.log(this.allCategories);
    console.log(this.categorieNiveau2v1);
    console.log(this.categoriesNiveau31);
  }
  setCategoriesNiveau2(j) {
    this.categorieNiveau3[j] = this.generalService.clone(this.categorie);
    // this.categorieNiveau1[j]=this.generalService.clone(this.categorie)
    console.log(this.categorieNiveau1[j]);
    console.log(this.categorieNiveau1);
    console.log(
      this.allCategories.filter((cat) => {
        return cat.categorie_CodeP == this.categorieNiveau1[j].categorie_Code;
      })
    );

    this.categoriesNiveau2[j] = this.allCategories.filter((cat) => {
      return cat.categorie_CodeP == this.categorieNiveau1[j].categorie_Code;
    });
    console.log(this.categoriesNiveau2[j]);
  }
  setCategoriesNiveau21() {
    this.categorieNiveau31 = this.generalService.clone(this.categorie);
    console.log(this.categorieNiveau1v1);
    this.categoriesNiveau2v1 = this.allCategories.filter((cat) => {
      return cat.categorie_CodeP == this.categorieNiveau1v1.categorie_Code;
    });
    console.log(this.categoriesNiveau2v1);
  }
  setTextInput(cat) {
    if (cat) {
      return cat.categorie_Text;
    }
  }
  setTextInputModel(model) {
    if (model) {
      return model.ecArtCarMod_Label;
    }
  }
  applyFilter(filterValue: string) {
    this.dataSourceCaracteristique.filter = filterValue.trim().toLowerCase();
  }
  importer(id) {
    document.getElementById("input_" + id).click();
  }

  suivant(f) {
    var test = false;
    if (
      f.controls.Art_Des.valid &&
      f.controls.Art_Garantie.valid &&
      f.controls.Art_PV.valid &&
      this.index == 0
    ) {
      test = true;
      this.activerFamilleArticle = false;
    }

    if (this.index == 1) {
      if (this.activerImagesArticle == false) test = true;
      else
        this.generalService.dialogSuccess(
          "SVP enregistez d'abord l'article",
          false
        );
    }

    if (this.index == 2) {
      test = true;
    }
    if (test) {
      this.index++;
    }
  }
  tabChanged() {
    if (this.index == 1 || this.index == 0) this.showBtn = true;
    else this.showBtn = false;
  }
  enregistrer(f) {
    //console.log(14);
    if (
      f.controls.Art_Des.valid &&
      f.controls.Art_Garantie.valid &&
      f.controls.Art_PV.valid &&
      // f.controls.categoriesNiv1.valid &&
      f.controls.etat.valid &&
      this.generalService.isNotEmpty(this.article.Art_Code)
    ) {
      var url = "";
      if (this.typeTrs == "1") url = this.generalService.urlArticle;
      else url = this.generalService.urlArticle + "&val=" + this.param_code;
      this.generalService.rechercheTable(url).subscribe(
        (art) => {
          var categorie_id = "";
          // if (this.categorieNiveau3.categorie_Code != null)
          //   categorie_id = this.categorieNiveau3.categorie_Code;
          // else if (this.categorieNiveau2.categorie_Code != null)
          //   categorie_id = this.categorieNiveau2.categorie_Code;
          // else
          //   categorie_id = this.categorieNiveau1.categorie_Code;

          art.Art[0].Art_Code = this.article.Art_Code;
          art.Art[0].categorie_id = categorie_id;
          art.Art[0].Art_Des = this.article.Art_Des;
          art.Art[0].Art_Garantie = this.article.Art_Garantie;
          art.Art[0].Art_CodeCpt = this.article.Art_CodeCpt;
          art.Art[0].Art_PV = this.article.Art_PV;
          art.Art[0].Art_PV1 = this.article.Art_PV1;
          art.Art[0].Art_Stock = this.article.Art_Stock;
          art.Art[0].Art_Des1 = this.article.Art_Des1;
          art.Art[0].Art_Des2 = this.article.Art_Des2;
          art.Art[0].Art_Des3 = this.article.Art_Des3;
          art.Art[0].Art_DL = this.article.Art_DL;
          art.Art[0].Art_Nature = this.article.Art_Nature;
          art.Art[0].Art_Stat5 = this.article.Art_Stat5;
          art.Art[0].Art_Stat4 = this.article.Art_Stat4;
          art.Art[0].Art_Poids = this.article.Art_Poids;
          art.Art[0].Art_Commentaire = this.article.Art_Commentaire;
          art.Art[0].Art_Variante1 = this.article.Art_Variante1;
          if (this.article.Art_Des4)
            art.Art[0].Art_Des4 = this.article.Art_Des4;
          art.Art[0].Art_Status = this.article.Art_Status;
          art.Art[0].Art_Stat2 =
            this.modelCaracteristiqueArticle.ecArtCarMod_Id;
          this.text[0][1] = this.article.Art_Des1;
          this.text[0][2] = this.article.Art_Des2;
          this.enregistrerLangue();
          this.generalService.enregisterTable(art).subscribe(
            (data) => {
              if (this.typeTrs == "1") {
                this.index = 2;
              }
              this.activerImagesArticle = false;
              this.activerDetailsArticle = false;
              this.activerProduit = false;
              this.enregistrementTerminer = false;
              this.enregistrementTerminer = true;
              this.param_code = this.article.Art_Code;
              this.uploadImageWithSave();
              this.typeTrs = "2";
              this.init();

              this.generalService.dialogSuccess("Article enregistrer", true);
            },
            (err) => {
              this.enregistrementTerminer = true;
              this.generalService.dialogSuccess("Article non enregisté", false);
            }
          );
        },
        (e) => {
          this.enregistrementTerminer = true;
        }
      );
    } else
      this.generalService.dialogSuccess(
        "Veuillez remplir tous les champs",
        false
      );
  }
  ListCat;
  getListCategorie(id) {
    this.generalService
      .rechercheTable(this.generalService.urlListCat + id)
      .subscribe((data) => {
        this.generalService
          .rechercheTable(this.generalService.urlListeCategorie)
          .subscribe(
            (cat) => {
              this.allCategories = cat;
              console.log(data);
              console.log("cattttttttt", cat);
              this.ListCat = data;

              console.log("the source", data);
              console.log("the local article", this.article);

              data.forEach((element, j) => {
                this.setCategoriesNiveau1(j);
              });
              this.setNiveauArticle();
            },
            (err) => {
              console.log(err);
            }
          );
      });
  }
  autoo;
  catNiv1v1;
  catNiv21;
  autoCategoriesNiveau2;
  autoCategoriesNiveau3;
  @ViewChild("dialogue") dialogue;
  add() {
    this.categoriesNiveau1v1 = this.allCategories.filter((cat) => {
      return cat.categorie_CodeP == null || cat.categorie_CodeP == "";
    });
    this.catNiv1v1 = null;
    this.catNiv21 = null;
    this.catNew = null;
    this.dialog.open(this.dialogue, { minWidth: 900 });
  }
  closeDialog() {
    this.dialog.closeAll();
  }
  deleteImageByClass(id, clas) {
    // this.generalService.rechercheTable(this.generalService.listImageByClass + id + ',' + clas).subscribe(res => {
    // console.log(res);
    // console.log(clas);

    // this.updateNbrImage(-1);
    // res.forEach(element => {
    this.generalService
      .supprimerSanMsgConfirm(this.selectedImage.File_Id, "avtFiles")
      .subscribe(
        (data2) => {
          this.checked.splice(this.lastIndexImage, 1);
          this.setImageDetaile();
        },
        () => { }
      );
  }
  catNew;
  deleteCat(j) {
    console.log(this.ListCat[j]);
    this.generalService
      .supprimer(this.ListCat[j].id, "ecArtCatArticle")
      .subscribe(
        (res) => {
          this.generalService.dialogSuccess("suppression avec succées", true);
          this.getListCategorie(this.article.Art_Code);
        },
        () => {
          this.generalService.dialogSuccess("Non enregistrer", false);
        }
      );
  }
  update(j) {
    console.log(this.ListCat[j]);
    console.log(this.ListCat);
    if (this.ListCat[j].id)
      this.generalService
        .rechercheTable(
          "ds/formdata?code=ecArtCatArticle&val=" + this.ListCat[j].id
        )
        .subscribe(
          (res) => {
            if (this.catNiv3[j]) {
              let catig = this.allCategories.find(
                (cat) => cat.categorie_Code == this.catNiv3Id[j]
              );
              res.ecArtCatArticle[0].categorie_Code = catig.categorie_Code;
              console.log(res);
            } else if (this.catNiv2[j]) {
              let catig = this.allCategories.find(
                (cat) => cat.categorie_Code == this.catNiv2Id[j]
              );
              res.ecArtCatArticle[0].categorie_Code = catig.categorie_Code;
              console.log(res);
            } else {
              let catig = this.allCategories.find(
                (cat) => cat.categorie_Code == this.catNiv1Id[j]
              );
              res.ecArtCatArticle[0].categorie_Code = catig.categorie_Code;
              console.log(res);
            }
            this.generalService.enregisterTable(res).subscribe(
              (resp) => {
                this.getListCategorie(this.article.Art_Code);
                this.generalService.dialogSuccess(
                  "mise à jour avec succées",
                  true
                );
              },
              () => {
                this.generalService.dialogSuccess("Non enregistrer", false);
              }
            );
          },
          () => {
            this.generalService.dialogSuccess("Non enregistrer", false);
          }
        );
  }
  // save() {
  //   let catig = this.allCategories.find(cat => cat.categorie_Text == this.catNew)
  //   console.log(this.catNew);
  //   console.log(catig);
  //   if (this.catNew && catig) {
  //     this.generalService.rechercheTable(this.generalService.dsListCat).subscribe(res => {
  //       console.log(res);
  //       res.ecArtCatArticle[0].Art_Code = this.article.Art_Code
  //       res.ecArtCatArticle[0].categorie_Code = catig.categorie_Code
  //       this.generalService.enregisterTable(res).subscribe(rep => {
  //         this.getListCategorie(this.article.Art_Code)
  //         this.catNew = null
  //         this.dialog.closeAll()
  //         this.generalService.dialogSuccess("ajout avec succées", true)
  //       }, () => {
  //         this.generalService.dialogSuccess("Non enregistrer", false)
  //       })

  //     })
  //   }
  //   else
  //     this.generalService.dialogSuccess("Choisir une catégorie", false)

  // }
  save() {
    if (
      this.idcategorieNiveau11 ||
      this.idcategorieNiveau21 ||
      this.idcategorieNiveau31
    ) {
      this.generalService
        .rechercheTable(this.generalService.dsListCat)
        .subscribe((res) => {
          console.log(res);
          res.ecArtCatArticle[0].Art_Code = this.article.Art_Code;
          if (this.idcategorieNiveau31)
            res.ecArtCatArticle[0].categorie_Code = this.idcategorieNiveau31;
          else if (this.idcategorieNiveau21)
            res.ecArtCatArticle[0].categorie_Code = this.idcategorieNiveau21;
          else res.ecArtCatArticle[0].categorie_Code = this.idcategorieNiveau21;
          this.generalService.enregisterTable(res).subscribe(
            (rep) => {
              this.getListCategorie(this.article.Art_Code);
              this.catNew = null;
              this.idcategorieNiveau11 = null;
              this.idcategorieNiveau21 = null;
              this.idcategorieNiveau31 = null;
              this.dialog.closeAll();
              this.generalService.dialogSuccess("ajout avec succées", true);
            },
            () => {
              this.generalService.dialogSuccess("Non enregistrer", false);
            }
          );
        });
    } else this.generalService.dialogSuccess("Choisir une catégorie", false);
  }
  enregistrerLangue() {
    try {
      // for (let i = 0; i < 2; i++) {
      //   for (let j = 0; j < this.text[0].length; j++) {
      //     this.generalService.rechercheTable("recherche/tbdata?tablere=Lg&param=" + i + "," + this.param_code + "_" + j).subscribe(data2 => {
      //       if (j == 6)
      //         console.log("lk")
      //       if (data2.length > 0) {
      //         this.generalService.modifierLanguage(data2[0].Lg_Id, this.text[i][j])
      //       }
      //       else {
      //         this.generalService.enregistrerLanguage(this.param_code + "_" + j, i, this.text[i][j])
      //       }
      //     })
      //   }
      // }
    } catch { }
  }
  readParamUrl() {
    this.route.params.subscribe((params) => {
      this.param_code = this.generalService.encodeDecodeProductRoute(params["param_code"], true);
      this.typeTrs = params["typeTrs"];
      this.init();
    });
  }
  getCatagories() {
    // this.generalService.rechercheTable(this.generalService.urlListeCategorie).subscribe(cat => {
    //   this.allCategories = cat;
    //   // cat.forEach((element,j) => {
    //   //   this.setCategoriesNiveau1(j);
    //   // });
    //   // if (this.typeTrs != "1")
    //     // this.setNiveauArticle();
    // },
    //   (e) => {
    //     this.enregistrementTerminer = true;
    //   })
  }
  getModel() {
    this.generalService
      .rechercheTable(this.generalService.urlListeModel)
      .subscribe(
        (data) => {
          this.modelAll = data;
          this.modelCaracteristiqueArticle = this.generalService.clone(
            this.modelAll.find((m) => {
              return m.ecArtCarMod_Id == this.article.Art_Stat2;
            })
          );
          if (this.modelCaracteristiqueArticle == undefined)
            this.modelCaracteristiqueArticle = {
              ecArtCarMod_Id: "",
              ecArtCarMod_Label: "",
            };
          this.listeModel = this.generalService.clone(this.modelAll);
        },
        (e) => {
          this.enregistrementTerminer = true;
        }
      );
  }
  getCaracteristiquesArticle() {
    this.enregistrementTerminer = false;
    this.listeCaracteristiquesArticle = [];
    this.generalService
      .rechercheTable(
        this.generalService.urlCarectiristique2 +
        "&val=" +
        this.article.Art_Code
      )
      .subscribe(
        (data) => {
          this.enregistrementTerminer = true;
          this.listeCaracteristiquesArticleBrut = data;
          if (
            this.listeCaracteristiquesArticleBrut.ecArtCarVal[0].ecArtCar_Id !=
            null
          ) {
            this.listeCaracteristiquesArticleBrut.ecArtCarVal.forEach((car) => {
              var ecArtCar_Label = this.ListeCaracteristiquesAll.find((c) => {
                return c.ecArtCar_Id == car.ecArtCar_Id;
              }).ecArtCar_Label;
              this.listeCaracteristiquesArticle.push({
                ecArtCar_Id: car.ecArtCar_Id,
                ecArtCar_Label: ecArtCar_Label,
                ecArtCar_Val: car.ecArtCar_Val,
              });
            });
            var listeCaracteristiqueModel = this.getListeCaracteristiqueModel(
              this.article.Art_Stat2
            );
            listeCaracteristiqueModel.forEach((car) => {
              if (
                this.listeCaracteristiquesArticle.find(
                  (caracteristiqueArticle) => {
                    return (
                      caracteristiqueArticle.ecArtCar_Id == car.ecArtCar_Id
                    );
                  }
                ) == undefined
              ) {
                this.listeCaracteristiquesArticle.push({
                  ecArtCar_Id: car.ecArtCar_Id,
                  ecArtCar_Label: car.ecArtCar_Label,
                  ecArtCar_Val: "",
                });
              }
            });
            this.dataSourceCaracteristique = new MatTableDataSource(
              this.generalService.clone(this.listeCaracteristiquesArticle)
            );
          } else if (
            this.generalService.isNotEmpty(this.categorieModelSelected)
          )
            this.dataSourceCaracteristique = new MatTableDataSource(
              this.getListeCaracteristiqueModel(
                this.categorieModelSelected.ecArtCarMod_Id
              )
            );

          this.activerDetailsArticle = false;
        },
        (e) => {
          this.enregistrementTerminer = true;
        }
      );
  }
  getCaracteristiques() {
    this.generalService
      .rechercheTable(this.generalService.urlListeCaracteristique)
      .subscribe(
        (data) => {
          this.ListeCaracteristiquesAll = data;
        },
        (e) => {
          this.enregistrementTerminer = true;
        }
      );
  }
  getProduitsComplementaireAndSimilaire() {
    console.log(14);
    this.generalService
      .rechercheTable(this.generalService.urlListeProduitComp + this.param_code)
      .subscribe(
        (listeArt) => {
          var listeArtComp = listeArt.filter((a) => {
            return a.ecArtComp_Type == "1";
          });
          var listeArtSimilair = listeArt.filter((a) => {
            return a.ecArtComp_Type == "2";
          });
          // for (let i = 0; i < listeArt.length; i++) {
          //   this.generalService
          //     .rechercheTable(
          //       this.generalService.urlArticle +
          //         "&val=" +
          //         listeArt[i].ecArtComp_Code
          //     )
          //     .subscribe((artC) => {
          //       // listeArt[i]["Art_Des"] = artC.Art[0].Art_Des;
          //     });
          // }
          this.dataSourceProduitsComplementaire = new MatTableDataSource(
            listeArtComp
          );
          this.dataSourceProduitsSimilaires = new MatTableDataSource(
            listeArtSimilair
          );
          console.log(this.dataSourceProduitsSimilaires);
        },
        (e) => {
          this.enregistrementTerminer = true;
        }
      );
  }
  filterImageByColor(listeImage, color) {
    return listeImage;
  }
  getCouleurPoiture() {
    try {
      this.generalService
        .rechercheTable(
          "recherche/tbdata?tablere=Art_T_C_S&param=" + this.param_code
        )
        .subscribe((data) => {
          this.listeColor = this.genererListeColor(
            this.generalService.distinct(data, "ArtV_Code1")
          );
          if (this.listeColor.length > 0) this.listeColor1 = this.listeColor; //.concat(this.listeColor1);
          // else
          // this.listeColor1 = this.listeColor.concat(this.listeColor1);
        });
    } catch { }
  }

  genererListeColor(listeColor) {
    var liste = [];
    listeColor.forEach((color) => {
      switch (color) {
        case "BLEU":
          liste.push({ ArtV_Code1: "BLEU", color: "#0000FF" });
          break;
        case "NOIR":
          liste.push({ ArtV_Code1: "NOIR", color: "#000000" });
          break;
        case "MARRON":
          liste.push({ ArtV_Code1: "MARRON", color: "#5B3C11" });
          break;
        case "CAMEL":
          liste.push({ ArtV_Code1: "CAMEL", color: "#bca78b" });
          break;
        case "ROUILLE":
          liste.push({ ArtV_Code1: "ROUILLE", color: "#985717" });
          break;
        case "TAN":
          liste.push({ ArtV_Code1: "TAN", color: "#D2B48C" });
          break;
        case "BLANC":
          liste.push({ ArtV_Code1: "BLANC", color: "#fffffff" });
          break;
      }
    });
    return liste;
  }
  verifierArticleParent() {
    if (this.article.Art_Nature == 1) {
      this.generalService
        .rechercheTable(
          "recherche/tbdata?tablere=ecArtGroupe&param=" + this.param_code
        )
        .subscribe((data) => {
          this.listeComponen.setDataSource(data);
        });
    }
  }
  init() {
    // this.getPdf()
    this.getInitDoc();
    this.initVariable();
    this.getCaracteristiques();
    if (this.typeTrs == "1") {
      console.log(14);
      this.generalService
        .rechercheTable(this.generalService.urlArticle)
        .subscribe(
          (art) => {
            this.ds = art;
            this.article = this.ds.Art[0];
            this.article.Art_NbrImages = 0;
            this.article.Art_Status = "1";
            this.article.Art_Des3 =
              "<table> <tr><td>Caractéristique</td><td>Valeur</td></tr>  <tr><td></td><td></td></tr></table>";
            // this.getCatagories();
            this.getListCategorie(this.article.Art_Code);
          },
          (e) => {
            this.enregistrementTerminer = true;
          }
        );
    } else if (this.typeTrs == "2" || this.typeTrs == "3") {
      console.log(14);
      this.generalService
        .rechercheTable(
          this.generalService.urlArticle + "&val=" + this.param_code
        )
        .subscribe(
          (art) => {
            this.ds = art;
            if (
              this.ds.Art[0].Art_Des3 == undefined ||
              this.ds.Art[0].Art_Des3 == null ||
              this.ds.Art[0].Art_Des3 == ""
            )
              this.ds.Art[0].Art_Des3 =
                "<table> <tr><td>Caractéristique</td><td>Valeur</td></tr> <tr><td></td><td></td></tr> </table>";
            this.article = this.ds.Art[0];
            this.getCatagories();
            this.verifierArticleParent();
            this.getModel();
            this.getListCategorie(this.article.Art_Code);
            this.getCaracteristiquesArticle();
            if (this.article.Art_NbrImages == null)
              this.article.Art_NbrImages = 0;
            this.activerFamilleArticle = false;
            this.activerImagesArticle = false;
            this.activerDetailsArticle = false;
            this.activerProduit = false;
            this.setImageDetaile();
            if (this.typeTrs == "3") {
              this.disabled = false;
            }
            this.getCouleurPoiture();
          },
          (e) => {
            this.enregistrementTerminer = true;
          }
        );
      this.getProduitsComplementaireAndSimilaire();
    }
  }
  catNiv1Id = [];
  catNiv2Id = [];
  setNiveauArticle() {
    var listeCodeNiveau1 = ";";
    this.ListCat.forEach((element, j) => {
      this.categoriesNiveau1[j].forEach((n1) => {
        listeCodeNiveau1 += n1.categorie_Code + ";";
      });
      var categorie = this.allCategories.find((cat) => {
        return cat.categorie_Code == element.categorie_Code;
      });
      if (categorie != undefined) {
        //niveau 1
        if (
          categorie.categorie_CodeP == null ||
          categorie.categorie_CodeP == ""
        ) {
          this.catNiv1[j] = categorie.categorie_Text;
          this.catNiv1Id[j] = categorie.categorie_Code;
          this.onCategoriesNiveau1Valuechange(
            { target: { value: categorie.categorie_Text } },
            j,
            true
          );
          this.categoriesNiveau1Selected(
            { option: { id: categorie.categorie_Code } },
            j,
            true
          );
        }
        //niveau 2
        else {
          var findCategorie = this.allCategories.find((cat) => {
            return cat.categorie_CodeP == categorie.categorie_Code;
          });
          if (findCategorie != undefined) {
            this.catNiv2[j] = categorie.categorie_Text;
            this.catNiv2Id[j] = categorie.categorie_Code;
            var catParent = this.allCategories.find((cat) => {
              return cat.categorie_Code == categorie.categorie_CodeP;
            });
            this.onCategoriesNiveau1Valuechange(
              { target: { value: catParent.categorie_Text } },
              j,
              true
            );
            this.categoriesNiveau1Selected(
              { option: { id: catParent.categorie_Code } },
              j,
              true
            );
            this.onCategoriesNiveau2Valuechange(
              { target: { value: categorie.categorie_Text } },
              j,
              true
            );
            this.categoriesNiveau2Selected(
              { option: { id: categorie.categorie_Code } },
              j,
              true
            );
            if (catParent != undefined) {
              this.catNiv1[j] = catParent.categorie_Text;
            }
          } else {
            //niveau 2
            if (
              listeCodeNiveau1.indexOf(";" + categorie.categorie_CodeP + ";") >=
              0
            ) {
              this.catNiv2[j] = categorie.categorie_Text;
              var catParent = this.allCategories.find((cat) => {
                return cat.categorie_Code == categorie.categorie_CodeP;
              });
              this.onCategoriesNiveau1Valuechange(
                { target: { value: catParent.categorie_Text } },
                j,
                true
              );
              this.categoriesNiveau1Selected(
                { option: { id: catParent.categorie_Code } },
                j,
                true
              );
              this.onCategoriesNiveau2Valuechange(
                { target: { value: categorie.categorie_Text } },
                j,
                true
              );
              this.categoriesNiveau2Selected(
                { option: { id: categorie.categorie_Code } },
                j,
                true
              );
              if (catParent != undefined) {
                this.catNiv1[j] = catParent.categorie_Text;
              }
            }
            //niveau 3
            else {
              this.catNiv3[j] = categorie.categorie_Text;
              this.catNiv3Id[j] = categorie.categorie_Code;
              var catParentNiv2 = this.allCategories.find((cat) => {
                return cat.categorie_Code == categorie.categorie_CodeP;
              });
              this.catNiv2[j] = catParentNiv2.categorie_Text;
              var catParentNiv1 = this.allCategories.find((cat) => {
                return cat.categorie_Code == catParentNiv2.categorie_CodeP;
              });
              if (catParentNiv1 != undefined) {
                this.catNiv1[j] = catParentNiv1.categorie_Text;
                this.onCategoriesNiveau1Valuechange(
                  { target: { value: catParentNiv1.categorie_Text } },
                  j,
                  true
                );
                this.categoriesNiveau1Selected(
                  { option: { id: catParentNiv1.categorie_Code } },
                  j,
                  true
                );
                this.onCategoriesNiveau2Valuechange(
                  { target: { value: catParentNiv2.categorie_Text } },
                  j,
                  true
                );
                this.categoriesNiveau2Selected(
                  { option: { id: catParentNiv2.categorie_Code } },
                  j,
                  true
                );
                this.onCategoriesNiveau3Valuechange(
                  { target: { value: categorie.categorie_Text } },
                  j,
                  true
                );
                this.categoriesNiveau3Selected(
                  { option: { id: categorie.categorie_Code } },
                  j,
                  true
                );
              }
            }
          }
        }
      }
    });
  }
  catNiv3Id = [];
  modifierOrderImage(index, orderImage) {
    this.enregistrementTerminer = false;
    var image = this.listeImages[index];
    this.generalService
      .rechercheTable(
        this.generalService.urlFiles +
        "&val=" +
        image.groupeImg.img_100_122[0].File_Id.toString()
      )
      .subscribe(
        (data) => {
          data.Files[0].File_Class = orderImage;
          this.generalService.enregisterTable(data).subscribe(
            (data) => {
              this.enregistrementTerminer = true;
              this.generalService.dialogSuccess("Enregisté", true);
            },
            (e) => {
              this.generalService.dialogSuccess("Non enregisté", false);
              this.enregistrementTerminer = true;
            }
          );
        },
        () => {
          this.enregistrementTerminer = true;
          this.generalService.dialogSuccess("Non enregisté", false);
        }
      );
  }
  modifierOrderImages(image, resolution) {
    console.log(image);

    this.resolution = resolution;
    this.nbImageModifier = 0;
    // var indexImage = image.File_Key.split("_")[1];

    if (this.resolution == "rectengle") {
      console.log(
        this.listeImgRectengle.find((img) => {
          return (
            img.File_Class == image.File_Class && img.File_Id != image.File_Id
          );
        }) == undefined
      );

      if (
        this.listeImgRectengle.find((img) => {
          return (
            img.File_Class == image.File_Class && img.File_Id != image.File_Id
          );
        }) == undefined
      ) {
        this.enregistrementTerminer = false;
        this.modifierImage(
          null,
          image.File_Id,
          null,
          null,
          "",
          this.listeResolutionRectangle.length,
          image.File_Class,
          image.File_Dll
        );
      } else this.generalService.dialogSuccess("Ce nombre existe déjà", false);
    }
  }
  modifierImage(
    file,
    File_Id,
    base64,
    name,
    text,
    nbrImage,
    File_Class?,
    File_Dll?
  ) {
    this.generalService
      .rechercheTable(
        this.generalService.urlFiles + "&val=" + File_Id.toString()
      )
      .subscribe(
        (data) => {
          if (name) data.Files[0].File_Text = this.article.Art_Code;
          if (File_Class) data.Files[0].File_Class = File_Class;
          if (File_Dll) data.Files[0].File_Dll = File_Dll;
          // data.Files[0].File_Key = data.Files[0].File_Key.split('_')[0] + '_' + File_Class;
          if (this.generalService.useDataBaseToSaveImage == 1) {
            if (base64) data.Files[0].File_Content = base64;
            this.modifierImg(data, nbrImage, text);
          } else {
            if (base64) {
              this.generalService.uploadFile2(file, name).subscribe(
                (data1) => {
                  console.log(data1);

                  data.Files[0].File_Content = data1["fileName"];
                  this.modifierImg(data, nbrImage, text);
                },
                (error) => {
                  console.log(error);
                }
              );
            } else {
              this.modifierImg(data, nbrImage, text);
            }
          }
        },
        (e) => {
          this.enregistrementTerminer = true;
        }
      );
  }
  modifierImg(data, nbrImage, text) {
    this.generalService.enregisterTable(data).subscribe(
      (data) => {
        this.nbImageModifier++;
        this.enregistrementTerminer = true;
        console.log("x");
        this.nbImageModifier = 0;
        this.setImageDetaile();
        this.generalService.dialogSuccess(text + " enregisté", true);
      },
      (e) => {
        this.generalService.dialogSuccess(text + " non enregisté", false);
        this.enregistrementTerminer = true;
      }
    );
  }
  supprimerDetailArticle() {
    if (this.row != undefined) {
      this.enregistrementTerminer = false;
      for (var i = 0; i < this.dataSourceCaracteristique.data.length; i++) {
        if (
          this.row.ecArtCar_Val ==
          this.dataSourceCaracteristique.data[i].ecArtCar_Val
        )
          this.listeCaracteristiquesArticleBrut.ecArtCarVal[i].ecArtCar_Val =
            "";
      }
      this.generalService
        .enregisterTable(this.listeCaracteristiquesArticleBrut)
        .subscribe(
          (Initcar) => {
            this.getCaracteristiquesArticle();
            this.enregistrementTerminer = true;
            this.generalService.dialogSuccess("Supprimer", true);
          },
          (err) => {
            this.enregistrementTerminer = true;
            this.generalService.dialogSuccess("Non Supprimer", false);
          }
        );
    } else {
      this.generalService.dialogSuccess(
        "Veuillez sélectionner une ligne",
        false
      );
    }
  }
  supprimerImages(resolution, color) {
    console.log(this.selectedImage);

    if (
      this.generalService.isNotEmpty(this.selectedImage) &&
      (color == this.selectedImage.File_Dll ||
        (this.listeColor1.length == 1 &&
          this.listeColor1[0].ArtV_Code1 == "-1"))
    ) {
      console.log(this.tabSelectedBefore);
      this.deleteImageByClass(
        this.article.Art_Code,
        this.tabSelectedBefore[this.tabSelectedBefore.length - 1].File_Class
      );
    } else
      this.generalService.dialogSuccess(
        "Veuillez sélectionner une image",
        false
      );
  }
  deleteAllImage() {
    this.generalService
      .rechercheTable(
        this.generalService.listImageByClass + this.article.Art_Code + "," + "0"
      )
      .subscribe((img) => {
        console.log(img);
        img.forEach((element) => {
          this.generalService
            .supprimerSanMsgConfirm(element.File_Id, "avtFiles")
            .subscribe((data2) => { });
        });
      });
  }
  updateNbrImage(nombre: number) {
    console.log(14);

    this.generalService
      .rechercheTable(
        this.generalService.urlArticle + "&val=" + this.param_code
      )
      .subscribe((art) => {
        console.log(this.resolution);
        this.ds = art;
        this.ds.Art[0].Art_NbrImages += nombre;
        this.article = this.ds.Art[0];
        this.generalService.enregisterTable(this.ds).subscribe((data) => {
          this.enregistrementTerminer = true;
          this.setImageDetaile();
        });
      });
  }
  enregistrementTerminerPDF = true;
  openFrmPdf(param) {
    document.getElementById("input_file").click();
    this.modePdf = param;
  }
  supprimerPdf() {
    // this.generalService.supprimer(this.pdfSelected.File_Id, "avtFiles").subscribe(data => {
    //   this.getPdf()
    //   this.showPdf = false
    //   this.pdfSelected = null
    //   this.generalService.dialogSuccess("pdf suppression avec succès", true);
    // },
    //   error => {
    //     this.generalService.dialogSuccess("Non enregistrer", false)
    //   });
    console.log(14);
    this.generalService
      .rechercheTable(
        this.generalService.urlArticle + "&val=" + this.param_code
      )
      .subscribe(
        (art) => {
          art.Art[0].Art_pdf = null;
          this.generalService
            .enregisterTable(art)
            .subscribe((updateArticle) => {
              this.article = art.Art[0];
              this.showPdf = false;
              this.generalService.dialogSuccess(
                "pdf supprimer avec succès",
                true
              );
            });
        },
        (error) => {
          this.generalService.dialogSuccess("Non enregistrer", false);
        }
      );
  }
  supprimerImage() {
    if (this.selectedImageDeatail != null) {
      this.enregistrementTerminer = false;
      var img_100_122 =
        this.listeImages[this.selectedImageDeatail].groupeImg.img_100_122;
      var img_268_327 =
        this.listeImages[this.selectedImageDeatail].groupeImg.img_268_327;
      var img_420_512 =
        this.listeImages[this.selectedImageDeatail].groupeImg.img_420_512;
      var img_850_1035 =
        this.listeImages[this.selectedImageDeatail].groupeImg.img_850_1035;
      this.generalService
        .supprimer(img_100_122[0].File_Id, "avtFiles")
        .subscribe(
          (data) => {
            this.generalService
              .supprimerSanMsgConfirm(img_268_327[0].File_Id, "avtFiles")
              .subscribe(
                (data) => {
                  this.generalService
                    .supprimerSanMsgConfirm(img_420_512[0].File_Id, "avtFiles")
                    .subscribe(
                      (data) => {
                        this.generalService
                          .supprimerSanMsgConfirm(
                            img_850_1035[0].File_Id,
                            "avtFiles"
                          )
                          .subscribe(
                            (data) => {
                              this.generalService.dialogSuccess(
                                "Supprimer",
                                true
                              );
                              this.setImageDetaile();
                              this.enregistrementTerminer = true;
                            },
                            (error) => {
                              this.enregistrementTerminer = true;
                              this.generalService.dialogSuccess(
                                "Erreur de mise à jour des données",
                                false
                              );
                            }
                          );
                      },
                      (error) => {
                        this.enregistrementTerminer = true;
                        this.generalService.dialogSuccess(
                          "Erreur de mise à jour des données",
                          false
                        );
                      }
                    );
                },
                (error) => {
                  this.enregistrementTerminer = true;
                  this.generalService.dialogSuccess(
                    "Erreur de mise à jour des données",
                    false
                  );
                }
              );
          },
          () => {
            this.enregistrementTerminer = true;
            this.generalService.dialogSuccess(
              "Erreur de mise à jour des données",
              false
            );
          }
        );
    } else {
      this.generalService.dialogSuccess(
        "Veuillez sélectionner une image",
        false
      );
    }
  }
  initVariable() {
    this.categoriesNiveau1v1 = [];
    this.categoriesNiveau2v1 = [];
    this.categoriesNiveau31 = [];
    this.dataSourceCaracteristique = new MatTableDataSource([]);
    this.disabled = false;
    this.successLoadData = false;
    this.categorieNiveau1 = [];
    this.categorieNiveau2 = [];
    this.categorieNiveau3 = [];
    this.categorieNiveau1v1 = this.generalService.clone(this.categorie);
    this.categorieNiveau2v1 = this.generalService.clone(this.categorie);
    this.categorieNiveau3v1 = this.generalService.clone(this.categorie);

    this.activerDetailsArticle = true;
    this.activerFamilleArticle = false;
    this.activerImagesArticle = true;
    this.activerProduit = true;
    this.article = {};
  }
  ClearTextComplementaire() {
    this.artComplementaire = null;
  }
  ClearTextSimilaires() {
    this.artSimilaires = null;
  }
  ajouterProduit(ecArtComp_Type) {
    var Comp_Type: number = 1;

    var existe: boolean = false;
    var art: any;
    switch (ecArtComp_Type) {
      case "1": {
        if (this.artComplementaire != null) {
          Comp_Type = 1;
          var data = this.dataSourceProduitsComplementaire.data.filter((p) => {
            return (
              p.Art_Code == this.article.Art_Code &&
              p.ecArtComp_Code == this.artComplementaire.Art_Code &&
              p.ecArtComp_Type == "1"
            );
          });
          if (data.length > 0) existe = true;
          art = this.artComplementaire;
          break;
        } else {
          this.generalService.dialogSuccess(
            "Veuillez sélectionner un article",
            false
          );
        }
      }
      case "2": {
        if (this.artSimilaires != null) {
          Comp_Type = 2;
          var data2 = this.dataSourceProduitsSimilaires.data.filter((p) => {
            return (
              p.Art_Code == this.article.Art_Code &&
              p.ecArtComp_Code == this.artSimilaires.Art_Code &&
              p.ecArtComp_Type == "2"
            );
          });
          if (data2.length > 0) existe = true;
          art = this.artSimilaires;
          break;
        } else {
          this.generalService.dialogSuccess(
            "Veuillez sélectionner un article",
            false
          );
        }
      }
    }
    if (!existe) {
      this.enregisterProduitComp(Comp_Type, art);
    } else {
      this.generalService.dialogSuccess("Cet article existe déjà", false);
    }
  }
  enregisterProduitComp(ecArtComp_Type: number, art) {
    this.enregistrementTerminer = false;
    this.generalService
      .rechercheTable(this.generalService.urlProduitComp)
      .subscribe(
        (prd) => {
          prd.ecArtComp[0].ecArtComp_Type = ecArtComp_Type;
          prd.ecArtComp[0].Art_Code = this.article.Art_Code;
          prd.ecArtComp[0].ecArtComp_Code = art.Art_Code;
          this.generalService.enregisterTable(prd).subscribe(
            (d) => {
              this.enregistrementTerminer = true;
              this.generalService.dialogSuccess("Enregistré", true);
              this.getProduitsComplementaireAndSimilaire();
            },
            (error) => {
              this.generalService.dialogSuccess("Non enregistré", false);
              this.enregistrementTerminer = true;
            }
          );
        },
        (error) => {
          this.enregistrementTerminer = true;
          this.generalService.dialogSuccess("Non enregistré", false);
        }
      );
  }
  supprimerProduitComplementaire() {
    if (this.rowComplementaire != undefined) {
      this.generalService
        .rechercheTable(
          this.generalService.urlIdArtComp +
          this.param_code +
          "," +
          this.rowComplementaire.Art_Code +
          "," +
          this.rowComplementaire.ecArtComp_Type
        )
        .subscribe(
          (resp) => {
            this.generalService
              .supprimer(resp[0]?.ecArtComp_Id, "ecArtComp")
              .subscribe(
                (data) => {
                  this.generalService.dialogSuccess("Article supprimer", true);
                  this.getProduitsComplementaireAndSimilaire();
                },
                () => {
                  this.generalService.dialogSuccess(
                    "Article non supprimer",
                    false
                  );
                }
              );
          },
          () => {
            this.generalService.dialogSuccess("Article non supprimer", false);
          }
        );
    } else {
      this.generalService.dialogSuccess(
        "Veuillez sélectionner un article",
        false
      );
    }
  }
  modifierProduitComplementaire() {
    if (this.rowComplementaire != undefined) {
      if (this.artComplementaire != null) {
        this.generalService
          .rechercheTable(
            this.generalService.urlIdArtComp +
            this.param_code +
            "," +
            this.rowComplementaire.Art_Code +
            "," +
            this.rowComplementaire.ecArtComp_Type
          )
          .subscribe(
            (resp) => {
              this.generalService
                .rechercheTable(
                  this.generalService.urlProduitComp +
                  "&val=" +
                  resp[0]?.ecArtComp_Id
                )
                .subscribe(
                  (data) => {
                    data.ecArtComp[0].ecArtComp_Code =
                      this.artComplementaire.Art_Code;
                    this.generalService.enregisterTable(data).subscribe(
                      (art) => {
                        this.generalService.dialogSuccess(
                          "Article modifier",
                          true
                        );
                        this.getProduitsComplementaireAndSimilaire();
                      },
                      (err) => {
                        this.generalService.dialogSuccess(
                          "Article non enregistré",
                          false
                        );
                        this.enregistrementTerminer = true;
                      }
                    );
                  },
                  (e) => {
                    this.enregistrementTerminer = true;
                  }
                );
            },
            (err) => {
              this.generalService.dialogSuccess(
                "Article non enregistré",
                false
              );
              this.enregistrementTerminer = true;
            }
          );
      } else {
        this.generalService.dialogSuccess(
          "Veuillez sélectionner un article",
          false
        );
      }
    } else {
      this.generalService.dialogSuccess(
        "Veuillez sélectionner une ligne",
        false
      );
    }
  }
  supprimerProduitSimilaires() {
    console.log(this.rowSimilaires);

    if (this.rowSimilaires != undefined) {
      this.generalService
        .rechercheTable(
          this.generalService.urlIdArtComp +
          this.param_code +
          "," +
          this.rowSimilaires.Art_Code +
          "," +
          this.rowSimilaires.ecArtComp_Type
        )
        .subscribe((resp) => {
          console.log(resp);

          this.generalService
            .supprimer(resp[0]?.ecArtComp_Id, "ecArtComp")
            .subscribe(
              (data) => {
                this.generalService.dialogSuccess("Article supprimer", true);
                this.getProduitsComplementaireAndSimilaire();
              },
              () => {
                this.generalService.dialogSuccess(
                  "Article non supprimer",
                  false
                );
              }
            ),
            () => {
              this.generalService.dialogSuccess("Article non supprimer", false);
            };
        });
    } else {
      this.generalService.dialogSuccess(
        "Veuillez sélectionner un article",
        false
      );
    }
  }
  modifierProduitSimilaires() {
    if (this.rowSimilaires != undefined) {
      if (this.artSimilaires != null) {
        this.generalService
          .rechercheTable(
            this.generalService.urlIdArtComp +
            this.param_code +
            "," +
            this.rowSimilaires.Art_Code +
            "," +
            this.rowSimilaires.ecArtComp_Type
          )
          .subscribe((resp) => {
            console.log();
            this.generalService
              .rechercheTable(
                this.generalService.urlProduitComp +
                "&val=" +
                resp[0]?.ecArtComp_Id
              )
              .subscribe(
                (data) => {
                  data.ecArtComp[0].ecArtComp_Code =
                    this.artSimilaires.Art_Code;
                  this.generalService.enregisterTable(data).subscribe(
                    (art) => {
                      this.generalService.dialogSuccess(
                        "Article modifier",
                        true
                      );
                      this.getProduitsComplementaireAndSimilaire();
                    },
                    (err) => {
                      this.enregistrementTerminer = true;
                      this.generalService.dialogSuccess(
                        "Article non enregistré",
                        false
                      );
                    }
                  );
                },
                (e) => {
                  this.enregistrementTerminer = true;
                }
              ),
              (err) => {
                this.enregistrementTerminer = true;
                this.generalService.dialogSuccess(
                  "Article non enregistré",
                  false
                );
              };
          });
      } else {
        this.generalService.dialogSuccess(
          "Veuillez sélectionner un article",
          false
        );
      }
    } else {
      this.generalService.dialogSuccess(
        "Veuillez sélectionner une ligne",
        false
      );
    }
  }
  getValeurCaracteristique(row) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = "200px";
    dialogConfig.height = "200px%";
    dialogConfig.autoFocus = true;
    dialogConfig.data = row;
    var dialogRef = this.dialog.open(
      ListeValeurCaracteristiqueModalComponent,
      dialogConfig
    );
    dialogRef.afterClosed().subscribe((result) => { });
  }
  removeSpecialCarater() {
    var str: string = "";
    for (var i = 0; i < this.article.Art_Code.length; i++) {
      var car = this.article.Art_Code.substring(i, i + 1);
      if (car == "~") str += "";
      else str += car;
    }
    this.article.Art_Code = str;
  }
  //  upload image marque
  lastEvent;
  imageMarqueSrc;
  imageMarqueName;
  importerMarque(id) {
    document.getElementById(id).click();
  }
  lastImageMarque = null;
  onChangeImageMarque(fileInput) {
    this.enregistrementTerminer = false;
    this.lastEvent = "upload";
    var file = fileInput.target.files[0];

    var reader = new FileReader();
    console.log(file.type);
    if (file.type.toString().indexOf("image") == 0) {
      reader.onload = (e) => {
        this.enregistrementTerminer = true;
        this.imageMarqueSrc = reader.result;
        this.imageMarqueName = fileInput.target.files[0].name;
        if (this.typeTrs != "1") this.uploadImageWithSave(file);
        else this.lastImageMarque = file;
      };
      reader.readAsDataURL(file);
    } else {
      this.enregistrementTerminer = true;
      this.generalService.dialogSuccess(
        "Veuillez sélectionner une image ",
        false
      );
    }
  }
  updateName(name) {
    const lastDotIndex = name.lastIndexOf(".");
    // If there's no dot or the name is already short enough, return the original name
    if (lastDotIndex === -1 || name.length <= 40) {
      return name;
    }
    const extension = name.substring(lastDotIndex);
    const maxMainNameLength = 39 - extension.length;
    return name.substring(0, maxMainNameLength) + extension;
  }
  uploadImageWithSave(file?) {
    if (this.generalService.cuurentUser == "BIGDAR") {
      if (this.typeTrs != "1" && file) {
        this.enregistrementTerminer = false;
        this.generalService
          .uploadFile2(file, this.updateName(file?.name))
          .subscribe(
            (data1) => {
              this.generalService
                .rechercheTable(
                  this.generalService.urlArticle + "&val=" + this.param_code
                )
                .subscribe(
                  (art) => {
                    art.Art[0].Art_Marque = data1["fileName"];
                    console.log(art);

                    this.generalService.enregisterTable(art).subscribe(
                      (data) => {
                        this.enregistrementTerminer = true;
                        this.generalService.dialogSuccess(
                          "Image marque enregistrer",
                          true
                        );
                      },
                      (err) => {
                        this.enregistrementTerminer = true;
                        this.generalService.dialogSuccess(
                          "Image marque non enregisté",
                          false
                        );
                      }
                    );
                  },
                  (err) => {
                    this.enregistrementTerminer = true;
                    this.generalService.dialogSuccess(
                      "Une erreur se produite",
                      false
                    );
                  }
                );
            },
            (err) => {
              this.enregistrementTerminer = true;
              this.generalService.dialogSuccess(
                "Une erreur se produite",
                false
              );
            }
          );
      } else {
        setTimeout(() => {
          console.log(this.lastImageMarque);
          console.log(this.lastImageMarque.name);

          this.generalService
            .uploadFile2(
              this.lastImageMarque,
              this.updateName(this.lastImageMarque.name)
            )
            .subscribe(
              (data1) => {
                this.generalService
                  .rechercheTable(
                    this.generalService.urlArticle + "&val=" + this.param_code
                  )
                  .subscribe(
                    (art) => {
                      art.Art[0].Art_Marque = data1["fileName"];
                      console.log(art);

                      this.generalService.enregisterTable(art).subscribe(
                        (data) => {
                          this.enregistrementTerminer = true;
                          this.generalService.dialogSuccess(
                            "Image marque enregistrer",
                            true
                          );
                        },
                        (err) => {
                          this.enregistrementTerminer = true;
                          this.generalService.dialogSuccess(
                            "Image marque non enregisté",
                            false
                          );
                        }
                      );
                    },
                    (err) => {
                      this.enregistrementTerminer = true;
                      this.generalService.dialogSuccess(
                        "Une erreur se produite",
                        false
                      );
                    }
                  );
              },
              (err) => {
                this.enregistrementTerminer = true;
                this.generalService.dialogSuccess(
                  "Une erreur se produite",
                  false
                );
              }
            );
        }, 0);
      }
    }
  }

  SupprimerMarque() {
    console.log(14);
    this.generalService
      .rechercheTable(
        this.generalService.urlArticle + "&val=" + this.param_code
      )
      .subscribe(
        (art) => {
          art.Art[0].Art_Marque = "";
          this.article.Art_Marque = "";
          this.imageMarqueSrc = null;
          this.generalService.enregisterTable(art).subscribe(
            (data) => {
              this.enregistrementTerminer = true;
              this.generalService.dialogSuccess("Image marque Supprimé", true);
            },
            (err) => {
              this.enregistrementTerminer = true;
              this.generalService.dialogSuccess(
                "Image marque non Supprimé",
                false
              );
            }
          );
        },
        (err) => {
          this.enregistrementTerminer = true;
          this.generalService.dialogSuccess("Une erreur se produite", false);
        }
      );
  }
}
